import { action } from "../../../utils/actions";

export const OPEN_NATIONAL_SOCIETY_STRUCTURE = action(
  "OPEN_NATIONAL_SOCIETY_STRUCTURE",
);

export const CREATE_REGION = action("CREATE_REGION");
export const EDIT_REGION = action("EDIT_REGION");
export const REMOVE_REGION = action("REMOVE_REGION");

export const CREATE_DISTRICT = action("CREATE_DISTRICT");
export const EDIT_DISTRICT = action("EDIT_DISTRICT");
export const REMOVE_DISTRICT = action("REMOVE_DISTRICT");

export const CREATE_VILLAGE = action("CREATE_VILLAGE");
export const EDIT_VILLAGE = action("EDIT_VILLAGE");
export const REMOVE_VILLAGE = action("REMOVE_VILLAGE");

export const CREATE_ZONE = action("CREATE_ZONE");
export const EDIT_ZONE = action("EDIT_ZONE");
export const REMOVE_ZONE = action("REMOVE_ZONE");
